

































































































// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';

// --- Models ---

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

// --- Third Party imports ---

@Component({
  components: {
    BaseMaterialCard,
  },
})
export default class ForgottenPassword extends Vue {
  valid: boolean = false;
  clicked: boolean = false;

  email: string = '';

  rules = {
      required: (value: string) => !!value || '',
      email: (value: string) => /(?:[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value) || 'E-mail must be valid',
  };

  // Functions

  async submit() {
    this.clicked = true;

    try {
      const response = await AuthService.forgotPasswordByEmail({ email: this.email });

      if (response.data.result === 'false') {
        AppService.errorHandler(response.data.message);
        // check if we got a multiple email address error:
        if (response.data.hasMultiple) {
          this.$router.push({ name: 'Forgotten Password By Username', params: { 
            email: this.email, 
          }});
        }
      } else {
        AppService.successHandler(response.data.message);
        this.$router.push({ name: 'Login' }); 
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }

    } finally {
      this.clicked = false;
    }
  }
}
